import { render } from "./RegisterForm.vue?vue&type=template&id=1a282cde"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"
script.render = render

export default script